// extracted by mini-css-extract-plugin
export var root = "MarkdownVideo-module--root--b01ad";